import { ROLES } from "../../common/enums";
import HomeIconMenu from "../../assets/ic20-home.png";
import contestIconMenu from "../../assets/ic20-contests.png";
import podcastIconMenu from "../../assets/ic20-podcast.png";
import newsIconMenu from "../../assets/ic20-news.png";
import contactsIconMenu from "../../assets/ic20-contacts.png";

export const linksForRoles: {
  [index: string]: {
    [index: string]: { title: string; path: string; icon?: any };
  };
} = {
  [ROLES.ADMIN]: {
    podcasts: {
      title: "Головна",
      path: "/",
      icon: HomeIconMenu,
    },
    news: {
      title: "Новини",
      path: "/news",
      icon: newsIconMenu,
    },
    involvement: {
      title: "Конкурси",
      path: "/contests",
      icon: contestIconMenu,
    },
    // podcasts: {
    //   title: "Подкасти",
    //   path: "/podcasts",
    //   icon: podcastIconMenu,
    // },
    contacts: {
      title: "Зв'язатися",
      path: "/contacts",
      icon: contactsIconMenu,
    },
  },
};
